// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

const STORAGE_KEY = 'charlies-main-auth';

// Custom localStorage wrapper with project-specific prefix to prevent
// auth token collisions when multiple Lovable/Supabase projects share
// the same .lovable.app domain.
const customStorage = {
  getItem: (key: string) => localStorage.getItem(`${STORAGE_KEY}-${key}`),
  setItem: (key: string, value: string) => localStorage.setItem(`${STORAGE_KEY}-${key}`, value),
  removeItem: (key: string) => localStorage.removeItem(`${STORAGE_KEY}-${key}`),
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storageKey: STORAGE_KEY,
    storage: customStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  }
});